import {useQuery} from '@tanstack/react-query'
import {httpGetWorkspaceDetails} from '../services/workspaces.http'
import {QUERY_KEYS} from '@/queryClient'

export const useGetWorkspaceDetails = ({id}: {id: string}) =>
    useQuery({
        queryKey: [QUERY_KEYS.WORKSPACE_DETAILS, id],
        queryFn: () => httpGetWorkspaceDetails(id)
    })
